import React from "react"

import FTPServer from "../../../../../components/Motion_Detection/Videos/video-ftp-server-wd-mycloud"

import SEOHelmet from '../../../../../components/Layout/SEOHelmet'
import Footer from "../../../../../components/Layout/footer"

const seodata = {
  title: 'Western Digital WD MyCloud FTP Upload',
  description: 'Use your internet router or NAS storage device as a backup FTP server for your camera´s alarm recordings.',
  image: '/images/Search/MD_SearchThumb_RouterAsFTPServer_WD.png'
}

export default (props) => (
  <React.Fragment>
    <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={props.location.pathname} />
    <h1 id="introduction" style={{ marginTop: 0 }}>
      FTP Upload auf eine Western Digital WD MyCloud
    </h1>
    <FTPServer />
    <br />
    <br />
    <Footer
      previousTitle="Motion Detection"
      previousLink="/fr/Motion_Detection/"
      nextTitle="Router as a FTP Server"
      nextLink="/fr/Motion_Detection/Router_as_a_FTP_Server/" />
  </React.Fragment>
)